export default __webpack_public_path__ + "static/Industrial_Cooker-20f29c232c7457f8a040acc3cf99e79d.png";